module.exports = __webpack_public_path__ + "static/media/quindio-54.1d6af67d.jpg";